// Districts of India — grouped by state. Phase 34.
// Alphabetically sorted; kept exhaustive for the states with the largest
// solar-CRM customer base (UP full 75-district list). Other states carry
// their canonical district list from the Government of India census.
// Add more states here as the business expands; no code changes needed
// elsewhere — the Select dropdown reads STATE_DISTRICTS[state] at runtime.

// -------- Uttar Pradesh (75 districts) --------
export const UP_DISTRICTS = [
    'Agra', 'Aligarh', 'Ambedkar Nagar', 'Amethi', 'Amroha', 'Auraiya', 'Ayodhya',
    'Azamgarh', 'Baghpat', 'Bahraich', 'Ballia', 'Balrampur', 'Banda', 'Barabanki',
    'Bareilly', 'Basti', 'Bhadohi', 'Bijnor', 'Budaun', 'Bulandshahr', 'Chandauli',
    'Chitrakoot', 'Deoria', 'Etah', 'Etawah', 'Farrukhabad', 'Fatehpur', 'Firozabad',
    'Gautam Buddha Nagar', 'Ghaziabad', 'Ghazipur', 'Gonda', 'Gorakhpur', 'Hamirpur',
    'Hapur', 'Hardoi', 'Hathras', 'Jalaun', 'Jaunpur', 'Jhansi', 'Kannauj', 'Kanpur Dehat',
    'Kanpur Nagar', 'Kasganj', 'Kaushambi', 'Kheri', 'Kushinagar', 'Lalitpur', 'Lucknow',
    'Maharajganj', 'Mahoba', 'Mainpuri', 'Mathura', 'Mau', 'Meerut', 'Mirzapur',
    'Moradabad', 'Muzaffarnagar', 'Pilibhit', 'Pratapgarh', 'Prayagraj', 'Raebareli',
    'Rampur', 'Saharanpur', 'Sambhal', 'Sant Kabir Nagar', 'Shahjahanpur', 'Shamli',
    'Shravasti', 'Siddharthnagar', 'Sitapur', 'Sonbhadra', 'Sultanpur', 'Unnao', 'Varanasi',
];

// -------- Other Indian States & UTs (Phase 34) --------
export const STATE_DISTRICTS = {
    'Uttar Pradesh': UP_DISTRICTS,
    'Bihar': [
        'Araria','Arwal','Aurangabad','Banka','Begusarai','Bhagalpur','Bhojpur','Buxar',
        'Darbhanga','East Champaran','Gaya','Gopalganj','Jamui','Jehanabad','Kaimur',
        'Katihar','Khagaria','Kishanganj','Lakhisarai','Madhepura','Madhubani','Munger',
        'Muzaffarpur','Nalanda','Nawada','Patna','Purnia','Rohtas','Saharsa','Samastipur',
        'Saran','Sheikhpura','Sheohar','Sitamarhi','Siwan','Supaul','Vaishali','West Champaran',
    ],
    'Delhi': [
        'Central Delhi','East Delhi','New Delhi','North Delhi','North East Delhi',
        'North West Delhi','Shahdara','South Delhi','South East Delhi','South West Delhi',
        'West Delhi',
    ],
    'Haryana': [
        'Ambala','Bhiwani','Charkhi Dadri','Faridabad','Fatehabad','Gurugram','Hisar',
        'Jhajjar','Jind','Kaithal','Karnal','Kurukshetra','Mahendragarh','Nuh','Palwal',
        'Panchkula','Panipat','Rewari','Rohtak','Sirsa','Sonipat','Yamunanagar',
    ],
    'Madhya Pradesh': [
        'Agar Malwa','Alirajpur','Anuppur','Ashoknagar','Balaghat','Barwani','Betul',
        'Bhind','Bhopal','Burhanpur','Chhatarpur','Chhindwara','Damoh','Datia','Dewas',
        'Dhar','Dindori','Guna','Gwalior','Harda','Hoshangabad','Indore','Jabalpur','Jhabua',
        'Katni','Khandwa','Khargone','Mandla','Mandsaur','Morena','Narsinghpur','Neemuch',
        'Niwari','Panna','Raisen','Rajgarh','Ratlam','Rewa','Sagar','Satna','Sehore',
        'Seoni','Shahdol','Shajapur','Sheopur','Shivpuri','Sidhi','Singrauli','Tikamgarh',
        'Ujjain','Umaria','Vidisha',
    ],
    'Rajasthan': [
        'Ajmer','Alwar','Banswara','Baran','Barmer','Bharatpur','Bhilwara','Bikaner',
        'Bundi','Chittorgarh','Churu','Dausa','Dholpur','Dungarpur','Ganganagar',
        'Hanumangarh','Jaipur','Jaisalmer','Jalore','Jhalawar','Jhunjhunu','Jodhpur',
        'Karauli','Kota','Nagaur','Pali','Pratapgarh','Rajsamand','Sawai Madhopur','Sikar',
        'Sirohi','Tonk','Udaipur',
    ],
    'Uttarakhand': [
        'Almora','Bageshwar','Chamoli','Champawat','Dehradun','Haridwar','Nainital',
        'Pauri Garhwal','Pithoragarh','Rudraprayag','Tehri Garhwal','Udham Singh Nagar',
        'Uttarkashi',
    ],
    'Punjab': [
        'Amritsar','Barnala','Bathinda','Faridkot','Fatehgarh Sahib','Fazilka','Ferozepur',
        'Gurdaspur','Hoshiarpur','Jalandhar','Kapurthala','Ludhiana','Malerkotla','Mansa',
        'Moga','Muktsar','Pathankot','Patiala','Rupnagar','Sangrur','SAS Nagar','SBS Nagar',
        'Tarn Taran',
    ],
    'Maharashtra': [
        'Ahmednagar','Akola','Amravati','Aurangabad','Beed','Bhandara','Buldhana','Chandrapur',
        'Dhule','Gadchiroli','Gondia','Hingoli','Jalgaon','Jalna','Kolhapur','Latur','Mumbai City',
        'Mumbai Suburban','Nagpur','Nanded','Nandurbar','Nashik','Osmanabad','Palghar','Parbhani',
        'Pune','Raigad','Ratnagiri','Sangli','Satara','Sindhudurg','Solapur','Thane','Wardha',
        'Washim','Yavatmal',
    ],
    'Gujarat': [
        'Ahmedabad','Amreli','Anand','Aravalli','Banaskantha','Bharuch','Bhavnagar','Botad',
        'Chhota Udaipur','Dahod','Dang','Devbhoomi Dwarka','Gandhinagar','Gir Somnath','Jamnagar',
        'Junagadh','Kheda','Kutch','Mahisagar','Mehsana','Morbi','Narmada','Navsari','Panchmahal',
        'Patan','Porbandar','Rajkot','Sabarkantha','Surat','Surendranagar','Tapi','Vadodara','Valsad',
    ],
    'West Bengal': [
        'Alipurduar','Bankura','Birbhum','Cooch Behar','Dakshin Dinajpur','Darjeeling','Hooghly',
        'Howrah','Jalpaiguri','Jhargram','Kalimpong','Kolkata','Malda','Murshidabad','Nadia',
        'North 24 Parganas','Paschim Bardhaman','Paschim Medinipur','Purba Bardhaman',
        'Purba Medinipur','Purulia','South 24 Parganas','Uttar Dinajpur',
    ],
    'Karnataka': [
        'Bagalkot','Ballari','Belagavi','Bengaluru Rural','Bengaluru Urban','Bidar','Chamarajanagar',
        'Chikballapur','Chikkamagaluru','Chitradurga','Dakshina Kannada','Davanagere','Dharwad',
        'Gadag','Hassan','Haveri','Kalaburagi','Kodagu','Kolar','Koppal','Mandya','Mysuru','Raichur',
        'Ramanagara','Shivamogga','Tumakuru','Udupi','Uttara Kannada','Vijayapura','Yadgir',
    ],
    'Tamil Nadu': [
        'Ariyalur','Chengalpattu','Chennai','Coimbatore','Cuddalore','Dharmapuri','Dindigul',
        'Erode','Kallakurichi','Kancheepuram','Kanyakumari','Karur','Krishnagiri','Madurai',
        'Mayiladuthurai','Nagapattinam','Namakkal','Nilgiris','Perambalur','Pudukkottai','Ramanathapuram',
        'Ranipet','Salem','Sivaganga','Tenkasi','Thanjavur','Theni','Thoothukudi','Tiruchirappalli',
        'Tirunelveli','Tirupathur','Tiruppur','Tiruvallur','Tiruvannamalai','Tiruvarur','Vellore',
        'Viluppuram','Virudhunagar',
    ],
    'Telangana': [
        'Adilabad','Bhadradri Kothagudem','Hanamkonda','Hyderabad','Jagtial','Jangaon','Jayashankar Bhupalpally',
        'Jogulamba Gadwal','Kamareddy','Karimnagar','Khammam','Kumurambheem Asifabad','Mahabubabad',
        'Mahabubnagar','Mancherial','Medak','Medchal-Malkajgiri','Mulugu','Nagarkurnool','Nalgonda',
        'Narayanpet','Nirmal','Nizamabad','Peddapalli','Rajanna Sircilla','Rangareddy','Sangareddy',
        'Siddipet','Suryapet','Vikarabad','Wanaparthy','Warangal','Yadadri Bhuvanagiri',
    ],
    'Chhattisgarh': [
        'Balod','Baloda Bazar','Balrampur','Bastar','Bemetara','Bijapur','Bilaspur','Dantewada',
        'Dhamtari','Durg','Gariaband','Gaurela-Pendra-Marwahi','Janjgir-Champa','Jashpur','Kabirdham',
        'Kanker','Kondagaon','Korba','Koriya','Mahasamund','Manendragarh-Chirmiri-Bharatpur',
        'Mohla-Manpur','Mungeli','Narayanpur','Raigarh','Raipur','Rajnandgaon','Sakti','Sarangarh-Bilaigarh',
        'Sukma','Surajpur','Surguja',
    ],
    'Odisha': [
        'Angul','Balangir','Balasore','Bargarh','Bhadrak','Boudh','Cuttack','Deogarh','Dhenkanal',
        'Gajapati','Ganjam','Jagatsinghpur','Jajpur','Jharsuguda','Kalahandi','Kandhamal','Kendrapara',
        'Kendujhar','Khordha','Koraput','Malkangiri','Mayurbhanj','Nabarangpur','Nayagarh','Nuapada',
        'Puri','Rayagada','Sambalpur','Subarnapur','Sundargarh',
    ],
    'Jharkhand': [
        'Bokaro','Chatra','Deoghar','Dhanbad','Dumka','East Singhbhum','Garhwa','Giridih','Godda',
        'Gumla','Hazaribagh','Jamtara','Khunti','Koderma','Latehar','Lohardaga','Pakur','Palamu',
        'Ramgarh','Ranchi','Sahibganj','Saraikela Kharsawan','Simdega','West Singhbhum',
    ],
    'Assam': [
        'Baksa','Barpeta','Biswanath','Bongaigaon','Cachar','Charaideo','Chirang','Darrang',
        'Dhemaji','Dhubri','Dibrugarh','Dima Hasao','Goalpara','Golaghat','Hailakandi','Hojai',
        'Jorhat','Kamrup','Kamrup Metropolitan','Karbi Anglong','Karimganj','Kokrajhar','Lakhimpur',
        'Majuli','Morigaon','Nagaon','Nalbari','Sivasagar','Sonitpur','South Salmara-Mankachar',
        'Tinsukia','Udalguri','West Karbi Anglong',
    ],
    'Himachal Pradesh': [
        'Bilaspur','Chamba','Hamirpur','Kangra','Kinnaur','Kullu','Lahaul & Spiti','Mandi','Shimla',
        'Sirmaur','Solan','Una',
    ],
    'Jammu & Kashmir': [
        'Anantnag','Bandipora','Baramulla','Budgam','Doda','Ganderbal','Jammu','Kathua','Kishtwar',
        'Kulgam','Kupwara','Poonch','Pulwama','Rajouri','Ramban','Reasi','Samba','Shopian','Srinagar',
        'Udhampur',
    ],
    'Andhra Pradesh': [
        'Anantapur','Chittoor','East Godavari','Guntur','Krishna','Kurnool','Nellore','Prakasam',
        'Srikakulam','Visakhapatnam','Vizianagaram','West Godavari','YSR Kadapa',
    ],
    'Kerala': [
        'Alappuzha','Ernakulam','Idukki','Kannur','Kasaragod','Kollam','Kottayam','Kozhikode',
        'Malappuram','Palakkad','Pathanamthitta','Thiruvananthapuram','Thrissur','Wayanad',
    ],
    'Goa': ['North Goa','South Goa'],
    'Chandigarh': ['Chandigarh'],
    'Puducherry': ['Karaikal','Mahe','Puducherry','Yanam'],
};

// Canonical state list for the dropdown — sorted alphabetically.
export const INDIAN_STATES = Object.keys(STATE_DISTRICTS).sort();

// Convenience helper — returns the district list for a state, or all UP districts
// when no state is picked (legacy default so existing UI stays intact).
export function districtsForState(state) {
    if (!state) return UP_DISTRICTS;
    return STATE_DISTRICTS[state] || [];
}

// Legacy alias — kept so any code that still imports { DISTRICTS } compiles.
export const DISTRICTS = STATE_DISTRICTS;

export const isValidUPDistrict = (d) => UP_DISTRICTS.includes((d || '').trim());
